module.exports = __webpack_public_path__ + "img/Bar@3x@3x.32af23c2.png";